import logo from "../assets/Logo.png";
import herobg from "../assets/HeroBg.jpg";
import launch from "../assets/start-up.svg";
import wrench from "../assets/wrench.svg";
import bulb from "../assets/bulb.svg";
import aboutbg from "../assets/aboutBg.jpg";
import astroplanet from "../assets/astro_planet.png";
import design from "../assets/design.png";
import development from "../assets/development.png";
import branding from "../assets/branding.png";
import toolsBg from "../assets/toolsBg.png";

import html from "../assets/html.png";
import sass from "../assets/sass.png";
import javascript from "../assets/javascript.png";
import react from "../assets/react.png";
import styled from "../assets/styled-components.png";
import git from "../assets/git.png";
import postgre from "../assets/postgre.png";
import node from "../assets/node.png";
import tailwind from "../assets/tailwind.png";
import figma from "../assets/figma.png";
import illustrator from "../assets/illustrator.png";
import photoshop from "../assets/photoshop.png";

import screens from "../assets/project-screen.png";
import contact from "../assets/contact-photo.jpg";
import contactbg from "../assets/contactBG.png";
import rocket from "../assets/rocket.png";
import rocketv from "../assets/rocketvec.svg";
import newbg from "../assets/NewBG.png";
import heromobile from "../assets/Hero-mobile.png";
import heroimage from "../assets/hero-image.png";
import stars from "../assets/stars.png";
import heroback from "../assets/heroback.jpg";

export default {
  logo,
  herobg,
  launch,
  wrench,
  bulb,
  aboutbg,
  astroplanet,
  design,
  development,
  branding,
  toolsBg,
  html,
  sass,
  javascript,
  react,
  styled,
  git,
  postgre,
  node,
  tailwind,
  figma,
  illustrator,
  photoshop,
  screens,
  contact,
  contactbg,
  rocket,
  rocketv,
  newbg,
  heromobile,
  heroimage,
  stars,
  heroback,
};
